'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.imageSwap = exports.init = undefined;

var _dom = require('../common/dom.js');

var _dom2 = _interopRequireDefault(_dom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var init = exports.init = function init() {
  bindUIActions();
  imageSwap();
};

var imageSwap = exports.imageSwap = function imageSwap() {
  $(_dom2.default.responsiveImageSwap).each(function () {
    var $current = $(this);
    var mobileImage = $current.attr('data-mobile-image');
    var desktopImage = $current.attr('data-desktop-image');

    var responsiveImage = void 0;
    if (mobileImage != undefined) {
      if ($(window).width() >= 768) {
        responsiveImage = desktopImage;
      } else {
        responsiveImage = mobileImage;
      }
    } else {
      responsiveImage = desktopImage;
    }

    $current.css('background-image', 'url(' + responsiveImage + ')');
  });
};

var bindUIActions = function bindUIActions() {
  $(window).on('resize', function () {
    imageSwap();
  });
};